import SoupsPage from './SoupsPage';
export default SoupsPage;
